(() => {
  'use strict';
  function cell(value) { const td = document.createElement('td'); td.textContent = value || '—'; return td; }
  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-usac-discovery-audit]').forEach(async (root) => {
    try {
      const response = await fetch(root.dataset.auditUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Audit data is unavailable.');
      const report = await response.json();
      const summary = root.querySelector('.usac-migration-audit__summary');
      summary.replaceChildren(...[
        report.summary.totalPages + ' legacy pages',
        report.summary.mapped + ' mapped guided destinations',
        report.summary.reviewRequired + ' review-required',
        report.summary.redirectsReady + ' redirects ready',
      ].map((text) => { const item = document.createElement('span'); item.textContent = text; return item; }));
      const table = document.createElement('table'); table.className = 'usac-migration-audit__table';
      table.innerHTML = '<thead><tr><th>Legacy page</th><th>Manufacturer</th><th>Status</th><th>Shopify destination</th><th>Reason</th><th>Journey parity</th><th>Validation</th></tr></thead>';
      const body = document.createElement('tbody');
      for (const record of report.pages || []) {
        const row = document.createElement('tr');
        row.append(cell(record.slug), cell(record.manufacturer), cell(record.status));
        const destination = document.createElement('td');
        if (record.destination) { const link = document.createElement('a'); link.href = record.destination; link.textContent = record.destination; destination.append(link); } else destination.textContent = '—';
        row.append(destination, cell(record.reason), cell(record.journey?.validation), cell(record.validation)); body.append(row);
      }
      table.append(body); root.querySelector('.usac-migration-audit__rows').replaceChildren(table);
    } catch {
      root.querySelector('.usac-migration-audit__summary').textContent = 'The migration audit asset is temporarily unavailable. No redirect status can be inferred from this page.';
    }
  }));
})();